var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pga-skeleton-loader",
    { attrs: { "is-loaded": _vm.isLoaded } },
    [_c("pga-business-startup-customer-order-edit")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }